"use client";

import "./Terms.scss";
import termsConfig from "./TermsConfig";
import PageBanner from "@/components/PageBanner/PageBanner";
import { Container } from "react-bootstrap";

const Terms = () => {
  const content = termsConfig.terms;

  return (
    <>
      <PageBanner title="Terms & Conditions" page="Terms" />

      <section className="terms-content-section">
        <Container>
          <div className="terms-container">
            {content.sections.map((section, i) => (
              <div key={i} className="terms-section">
                <p className="terms-intro">{section.introduction}</p>
                <h2 className="terms-heading">{section.heading}</h2>

                {section.content.map((c, j) => (
                  <div key={j}>
                    {c.subheading && (
                      <h3 className="terms-subheading">{c.subheading}</h3>
                    )}
                    {c.text && <p className="terms-text">{c.text}</p>}

                    {c.list && (
                      <ul>
                        {c.list.map((item, k) => (
                          <li key={k}>{item}</li>
                        ))}
                      </ul>
                    )}
                  </div>
                ))}
              </div>
            ))}

            <p className="terms-conclusion">{content.conclusion}</p>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Terms;
